export const UPDATE_FIELD = "UPDATE_FIELD";
export const INIT_ANSWERS = "INIT_ANSWERS";
export const SET_ANSWER = "SET_ANSWER";
export const IS_COMPLETED = "IS_COMPLETED";
